import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/raw-purchases`;

export const getPurchases = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const getPurchaseById = async (pid, rpsid) => {
  return await axiosInstance.get(`${BASE(pid)}/${rpsid}`);
};

export const createPurchase = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updatePurchase = async (pid, rpsid, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${rpsid}`, data);
};

export const deletePurchase = async (pid, rpsid) => {
  return await axiosInstance.delete(`${BASE(pid)}/${rpsid}`);
};